/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { updateTeam, addTeam, clearTeamData } from '../../actions/teamActions';
import CheckBox from '../Common/checkbox';

class NewTeamMember extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: {}
    };
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  handleSave(event) {
    event.preventDefault();
    const { checked } = this.state;
    const { team, users } = this.props;
    const userIds = Object.keys(checked).filter((key) => checked[key]);
    const updatedTeam = { ...team, members: [...team.members] };
    userIds.forEach((id) => {
      const user = users.find((u) => u.id.toString() === id);
      updatedTeam.members.push(user);
    });
    if (team.id > 0) {
      this.props.updateTeam(updatedTeam.id, updatedTeam).then(() => {
        if (!this.props.openModals.find((value) => value === 'newTeam'))
          this.props.clearTeamData();
      });
    }
    this.props.addTeam(updatedTeam);
    this.props.onClose(null, 'newTeamMember');
  }

  handleCheckboxChange(id) {
    const { checked } = this.state;
    checked[id] = !checked[id];
    this.setState({ checked });
  }

  render() {
    if (!this.props.isOpen) {
      return null;
    }
    const { users, team } = this.props;
    const { checked } = this.state;

    return (
      <div className="detail-modal" tabIndex="-1" role="dialog">
        <div className="detail-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="col-sm-10">
                <h4 className="modal-title">Add Member</h4>
              </div>
              <div className="col-sm-2 detail-close">
                <button
                  type="button"
                  className="close"
                  onClick={() => this.props.onClose(null, 'newTeamMember')}
                >
                  <span>&times;</span>
                </button>
              </div>
            </div>
            <div className="modal-body">
              {users
                .sort((a, b) => a.name.localeCompare(b.name))
                .filter(
                  (u) =>
                    team.members.findIndex((m) => u.id === m.id) < 0 &&
                    !u.deleted_at
                )
                .map((user) => (
                  <div className="team-member-options">
                    <CheckBox
                      key={`member_${team.id}_${user.id}`}
                      label={user.name}
                      value={user.id}
                      checked={!!checked[user.id]}
                      handleCheckboxChange={this.handleCheckboxChange}
                    />
                  </div>
                ))}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-xs button-lavender"
                onClick={this.handleSave}
              >
                <strong>Save</strong>
              </button>
              <button
                type="button"
                className="btn btn-xs btn-default button-normal"
                onClick={() => this.props.onClose(null, 'newTeamMember')}
              >
                <strong>Cancel</strong>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

NewTeamMember.propTypes = {
  team: PropTypes.object,
  users: PropTypes.array,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  updateTeam: PropTypes.func
};

NewTeamMember.defaultProps = {
  team: {
    short_name: '',
    description: '',
    members: []
  }
};

const mapStateToProps = (state) => ({
  users: state.userReducer.users,
  openModals: state.modalReducer.openModals
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateTeam,
      addTeam,
      clearTeamData
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(NewTeamMember);
